import React from 'react';
import { Link } from 'react-router-dom';
import BlogCard from '../blog/BlogCard';
import { blogPosts } from '../../data/blogPosts';

const HomeBlogs = () => {
  const previewCount = 3;
  const posts = blogPosts.slice(0, previewCount);
  const hasMore = blogPosts.length > previewCount;

  return (
    <section className="bg-bg-light px-6 py-14 md:px-12">
      <div className="mx-auto max-w-6xl">
        <div className="mb-10 flex flex-col items-center gap-4 text-center md:mb-12 md:flex-row md:justify-between md:text-left">
          <h2 className="text-3xl font-bold uppercase text-accent md:text-4xl">
            Blogs
          </h2>
          {hasMore && (
            <Link
              to="/blog"
              className="text-sm font-semibold text-accent hover:underline md:text-base"
            >
              View all blogs →
            </Link>
          )}
        </div>

        <div
          className={
            posts.length === 1
              ? 'mx-auto max-w-md'
              : 'grid gap-8 sm:grid-cols-2 lg:grid-cols-3'
          }
        >
          {posts.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeBlogs;
